module.exports = __webpack_public_path__ + "static/media/34.074d7c7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/34.png
// module id = 538
// module chunks = 0